// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"c8eabd54","167":"2aacfb28","243":"1ade7af8","325":"dca8d59d","398":"75c61caf","453":"d1b210b6","654":"b14c215d","758":"89f0a05e","822":"f1217cfb","901":"13a3ddf4"}[chunkId] + ".chunk.js";
};